import { render, staticRenderFns } from "./IbanPopup.vue?vue&type=template&id=727f47c8"
import script from "./IbanPopup.vue?vue&type=script&lang=js"
export * from "./IbanPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports